import type { GetServerSideProps } from "next";

import { loadPageWithGlobal } from "@shared/api";
import type { GlobalType } from "@shared/content-types/types";

import { getOtherPage } from "@/_pages/article/api";
import type { ArticleType } from "@/_pages/article/model";
import { ArticlePage } from "@/_pages/article/ui";

type Params = {
  page: string;
};

type PageProps = {
  cms: ArticleType;
  global?: GlobalType | null;
};

const Page = (props: PageProps) => {
  const { cms, global } = props;

  return <ArticlePage article={cms} formSettings={global?.feedbackForm} />;
};

export const getServerSideProps: GetServerSideProps<{}, Params> = async (
  context,
) => {
  const { res } = context;
  const { page } = context.params!;

  return await loadPageWithGlobal(
    async () => {
      const { article } = await getOtherPage(page);

      return {
        ...article,
      };
    },
    { res },
  );
};

export default Page;
